import Hogan from 'hogan.js';
import FacetHelper from './facet';
import HitHelper from './hit';
import PaginationHelper from './pagination';
import StatsHelper from './stats';

const { $ } = window;
const templates = [
  'facet',
  'hit',
  'pagination',
  'stats'
];

/**
 * Mandatory options: config, helper
 * @param {Object}
 */
export default class Renderer {
  constructor(options) {
    Object.assign(this, options);
    this.initElements();
    templates.forEach(this.initTemplate.bind(this));
  }

  /**
   * Renders facets
   */
  facets() {
    const options = {
      content: this.content,
      el: this.$facets,
      facets: this.config.FACET_CONFIG,
      helper: this.helper,
      hitCount: this.content.hits.length,
      tmpl: this.facetTemplate
    };
    new FacetHelper(options).render();
  }

  /**
   * Renders hits
   */
  hits() {
    const options = {
      el: this.$hits,
      hits: this.content.hits,
      tmpl: this.hitTemplate
    };
    new HitHelper(options).render();
  }

  /**
   * Caches elements
   */
  initElements() {
    this.$facets = $('#facets');
    this.$hits = $('#hits');
    this.$pagination = $('#pagination');
    this.$stats = $('#stats');
  }

  /**
   * Takes a template name and uses it to gather template code before
   * passing compiling it with Hogan
   * @param {String} template
   */
  initTemplate(template) {
    const tmpl = $(`#${template}-template`).text();
    this[`${template}Template`] = Hogan.compile(tmpl);
  }

  pagination() {
    const options = {
      el: this.$pagination,
      tmpl: this.paginationTemplate
    };
    new PaginationHelper(options).render();
  }

  /**
   * Takes Algolia's content/state on search results and renders the results
   * @param {Object} content Algolia content
   * @param {Object} state Algolia state
   */
  render(content, state) {
    Object.assign(this, { content, state });
    this.facets();
    this.hits();
    this.pagination();
    this.stats();

    // Run any special callbacks for the resultsLoaded custom event
    // i.e. hit formatters, etc
    window.dispatchEvent(new CustomEvent('resultsLoaded', { bubbles: true }));
  }

  /**
   * Renders stats
   */
  stats() {
    const options = {
      el: this.$stats,
      hitCount: this.content.nbHits,
      time: this.content.processingTimeMS,
      tmpl: this.statsTemplate
    };
    new StatsHelper(options).render();
  }
}
